<template>
  <div class="p-postEditor__itemWrapper">
    <div v-show="editingItemIndex !== index" @click="editItemAndSetItem">
      <template v-if="(item.itemableAttributes.tab === undefined && item.itemableAttributes.productId) || item.itemableAttributes.tab == 1">
        <selected-product-introduction-item-preview :item="item" :product="item.itemableAttributes.product" />
      </template>
      <template v-else>
        <product-introduction-item-preview :item="item" />
      </template>
    </div>
    <template v-if="editingItemIndex === index">
      <v-card class='pa-5'>
        <v-tabs v-model="tab" class='original-v-tabs'>
          <v-tab value="direct_input" style="height: 30px; padding: 0 10px;">直接入力する</v-tab>
          <v-tab value="select_product" style="height: 30px; padding: 0 10px;">登録済みの商品から選ぶ</v-tab>
          <v-tab-item>
            <item-form :item="item">
              <v-row>
                <v-col class="pa-0">
                  <images-form
                    :item="item"
                    :affi-images="affiImages"
                    @update-editing-itemable-images="updateEditingItemableImages"
                  />
                </v-col>
              </v-row>
              <v-row class="ma-0 mt-3">
                <v-col lg="5" class="pa-0 ml-5 mr-3">
                  <v-text-field
                    :value="editingItemable.alternateName"
                    dense
                    @input="updateEditingItemable($event, 'alternateName')"
                  >
                    <template v-slot:label>
                      <InputLabel label-name="ブランド・メーカー名" />
                    </template>
                  </v-text-field>
                  <v-text-field
                    :value="editingItemable.name"
                    :rules="[presenceValidation]"
                    autofocus
                    dense
                    required
                    @input="updateEditingItemable($event, 'name')"
                  >
                    <template v-slot:label>
                      <InputLabel label-name="商品名" :required="true" />
                    </template>
                  </v-text-field>
                  <v-row>
                    <v-col lg="4" md="12" sm="12">
                      <v-select
                        :value="editingItemable.taxIncluded"
                        :items="taxIncludedSelectItems"
                        class="mr-1"
                        label="税表示"
                        dense
                        single-line
                        @change="updateEditingItemable($event, 'taxIncluded')"
                      />
                    </v-col>
                    <v-col>
                      <v-text-field
                        :value="editingItemable.price"
                        type="number"
                        dense
                        @input="updateEditingItemable($event, 'price')"
                      >
                        <template v-slot:label>
                          <InputLabel label-name="価格（円）" />
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-textarea
                    :value="editingItemable.description"
                    rows="2"
                    dense
                    @input="updateEditingItemable($event, 'description')"
                  >
                    <template v-slot:label>
                      <InputLabel label-name="説明文" />
                    </template>
                  </v-textarea>
                </v-col>
                <v-divider vertical></v-divider>
                <v-col lg="6" class="pa-0 ml-3">
                  <v-text-field
                    :value="editingItemable.officialUrl"
                    :rules="[urlValidation]"
                    dense
                    @input="updateEditingItemable($event, 'officialUrl')"
                  >
                    <template v-slot:label>
                      <InputLabel label-name="公式サイト（EC）URL" />
                    </template>
                  </v-text-field>
                  <template v-if="site.amazonPaApiAvailable">
                    <AffiliateSetting
                      service-name="Amazon"
                      :affi-link="editingItemable.amazonUrl || ''"
                      @open-dialog="amazonAffiSettingDialog = true"
                      @delete-affi-link="updateEditingItemable('', 'amazonUrl')"
                    />
                  </template>
                  <template v-else>
                    <v-text-field
                      :value="editingItemable.amazonUrl"
                      :rules="[urlValidation]"
                      dense
                      @input="updateEditingItemable($event, 'amazonUrl')"
                    >
                      <template v-slot:label>
                        <InputLabel label-name="amazonURL" />
                      </template>
                    </v-text-field>
                  </template>
                  <template v-if="site.rakutenIchibaApiAvailable">
                    <AffiliateSetting
                      service-name="楽天"
                      :affi-link="
                        editingItemable.rakutenUrl ? editingItemable.rakutenUrl : ''
                      "
                      @open-dialog="rakutenDialog = true"
                      @delete-affi-link="updateEditingItemable('', 'rakutenUrl')"
                    />
                  </template>
                  <template v-else>
                    <v-text-field
                      :value="editingItemable.rakutenUrl"
                      :rules="[urlValidation]"
                      dense
                      @input="updateEditingItemable($event, 'rakutenUrl')"
                    >
                      <template v-slot:label>
                        <InputLabel label-name="rakutenURL" />
                      </template>
                    </v-text-field>
                  </template>
                  <v-text-field
                    :value="editingItemable.otherUrl"
                    :rules="[urlValidation]"
                    dense
                    class="mt-2"
                    @input="updateEditingItemable($event, 'otherUrl')"
                  >
                    <template v-slot:label>
                      <InputLabel label-name="その他EC/アフィリエイトURL" />
                    </template>
                  </v-text-field>
                  <v-text-field
                    :value="editingItemable.otherUrlSentence"
                    dense
                    class="mt-2"
                    @input="updateEditingItemable($event, 'otherUrlSentence')"
                  >
                    <template v-slot:label>
                      <InputLabel
                        label-name="その他EC/アフィリエイトURLリンクタイトル"
                      />
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </item-form>
          </v-tab-item>
          <v-tab-item>
            <item-form :item="item">
              <div v-if='editingItemable.product' style="display: flex;">
                <table>
                  <tr>
                    <td>
                      <img
                        v-if="productEyecatch(editingItemable.product)"
                        :src="productEyecatch(editingItemable.product)"
                        :alt="productEyecatchAlt(editingItemable.product).altAttribute"
                        class="p-productTable__td__image px-1"
                        style="max-width: 150px;"
                      />
                      <img
                        v-else
                        src="https://placehold.jp/eeeeee/cccccc/200x200.png?text=No%20Image"
                        alt="no-image"
                        class="p-productTable__td__image px-1"
                        style="max-width: 150px;"
                      />
                    </td>
                    <td valign="top">
                      <p class='ml-3'>{{ editingItemable.product.name }}</p>
                    </td>
                    <td valign="top">
                      <v-btn small variant="outlined" class='mr-1 warning white--text' @click="emptyProduct()">商品を選び直す</v-btn>
                    </td>
                  </tr>
                </table>
              </div>
              <div v-else>
                <div style="width: 100%; margin: 0 auto; height: 430px; overflow-y: scroll;">
                  <ProductSelecter
                    @select-product="selectProduct"
                  />
                </div>
              </div>
            </item-form>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </template>
    <amazonAffiSettingDialog
      :dialog="amazonAffiSettingDialog"
      :search-result-products="
        searchResultProducts.length !== 0 ? searchResultProducts : []
      "
      @select-product="selectAmazonProduct"
      @close-dialog="closeAmazonDialog"
    />
    <ItemAddRakutenInfo
      :rakuten-dialog="rakutenDialog"
      @update-editing-rakuten-item="setRakutenItem"
      @close-dialog="closeRakutenDialog"
    />
  </div>
</template>

<script>
import itemUtilsMixin from '@/mixins/item_utils'
import imageUtilsMixin from '@/mixins/image_utils'
import InputLabel from '@/components/commons/formParts/inputLabel'
import ProductIntroductionItemPreview from './previews/ProductIntroductionItemPreview'
import SelectedProductIntroductionItemPreview from './previews/SelectedProductIntroductionItemPreview'
import ImagesForm from '@/components/commons/productIntroductions/ImagesForm'
import AffiliateSetting from '@/components/commons/productIntroductions/AffiliateSetting'
import ItemAddRakutenInfo from '@/components/commons/productIntroductions/ItemAddRakutenInfo'
import amazonAffiSettingDialog from '@/components/commons/productIntroductions/amazonAffiSettingDialog'
import { mapState } from 'vuex'
import formValidationUtils from '@/mixins/form_validation_utils'
import ProductSelecter from '@/components/postEditor/parts/ProductSelecter'

export default {
  name: 'ProductIntroductionItem',
  components: {
    ProductIntroductionItemPreview,
    InputLabel,
    ImagesForm,
    AffiliateSetting,
    amazonAffiSettingDialog,
    ItemAddRakutenInfo,
    ProductSelecter,
    SelectedProductIntroductionItemPreview
  },
  mixins: [itemUtilsMixin, imageUtilsMixin, formValidationUtils],
  data: () => {
    return {
      taxIncludedSelectItems: [
        { text: '税込', value: true },
        { text: '税抜', value: false }
      ],
      amazonAffiSettingDialog: false,
      searchResultProducts: [],
      rakutenDialog: false,
      affiImages: [],
      rakutenKeyword: ''
    }
  },
  computed: {
    ...mapState({
      site: (state) => state.SiteStore.site
    }),
    tab: {
      get () {
        return this.editingItemable.tab
      },
      set (value) {
        this.updateEditingItemable(value, 'tab')
      }
    }
  },
  methods: {
    selectAmazonProduct (product) {
      this.updateEditingItemable(product.detailPageUrl, 'amazonUrl')
      this.updateEditingItemable(product.asin, 'amazonCode')
      this.affiImages.push(product.images.primary.large.url)
      if (product.images.variants) {
        product.images.variants.forEach((image) =>
          this.affiImages.push(image.large.url)
        )
      }
      if (
        !this.editingItemable.alternateName &&
        this.brandDisplayValue(product)
      ) {
        this.updateEditingItemable(
          product.itemInfo.byLineInfo.brand.displayValue,
          'alternateName'
        )
      }
      if (!this.editingItemable.name) {
        this.updateEditingItemable(product.itemInfo.title.displayValue, 'name')
      }
      this.amazonAffiSettingDialog = false
    },
    brandDisplayValue (product) {
      if (
        product.itemInfo.byLineInfo &&
        product.itemInfo.byLineInfo.brand &&
        product.itemInfo.byLineInfo.brand.displayValue
      ) {
        return true
      } else {
        return false
      }
    },
    setRakutenItem (value) {
      if (!this.editingItemable.name) {
        this.updateEditingItemable(value.name, 'name')
      }

      if (value.affiliateSerch) {
        this.updateEditingItemable(value.affiliateSearch, 'rakutenUrl')
      } else {
        this.updateEditingItemable(value.affiliate, 'rakutenUrl')
      }

      this.updateEditingItemable(value.price, 'price')
      this.updateEditingItemable(value.rakutenCode, 'rakutenCode')
      this.updateEditingItemable(value.description, 'description')
      this.affiImages.push(...value.imagesUrl)
      this.rakutenDialog = false
    },
    updateEditingItemableImages (images) {
      this.updateEditingItemable(images, 'images')
    },
    closeAmazonDialog () {
      this.amazonAffiSettingDialog = false
    },
    closeRakutenDialog () {
      this.rakutenDialog = false
    },
    selectProduct (product) {
      this.updateEditingItemable(product, 'product')
      this.updateEditingItemable(product.id, 'productId')
    },
    productEyecatch (product) {
      if (product.productImages == undefined || product.productImages.length == 0) return

      const productImage = product.productImages.reduce((previousImage, currentImage) =>
        previousImage.priority > currentImage.priority
          ? currentImage
          : previousImage
      )
      return this.getFilePath(productImage.file.url)
    },
    productEyecatchAlt (product) {
      if (!product.productImages) return

      return product.productImages.reduce((previousImage, currentImage) =>
        previousImage.priority > currentImage.priority
          ? currentImage
          : previousImage
      )
    },
    editItemAndSetItem () {
      this.editItem()
      if (this.tab === undefined && this.item.itemableAttributes.productId) {
        this.tab = 1
      }
    },
    emptyProduct () {
      this.updateEditingItemable(null, 'product')
    }
  }
}
</script>

<!-- scopedを入れるとcssが効かない。タブが大きくなる。 -->
<style>
.original-v-tabs .v-item-group {
  height: fit-content;
}
</style>
